// extracted by mini-css-extract-plugin
export default {"categoryCarousel":"CategoryCarousel-module__categoryCarousel___1lfk3"};